// ---------------------------------------------- modules import
import M from "materialize-css";
import React, { FunctionComponent, useEffect } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import Spinner from "react-spinkit";

import Row from "./row";
import SearchForm from "./searchForm";

import { ITableProps } from "./common";
import { useAuth, useUsers } from "./hooks";
import { ThemeContext } from "../../../contexts/themeContext";
import PermissionHelper, {
  MenuIndex
} from "../../../store/helpers/permissionHelper";

// ---------------------------------------------- the component
const Table: FunctionComponent<ITableProps> = ({ menuIndex }) => {
  // ---------------------------------------------- router state
  let match = useRouteMatch();

  // ---------------------------------------------- local state
  const { profile } = useAuth();
  const { loading, error, fetching, filtered, criteria, onFilter } = useUsers(
    menuIndex
  );

  // ---------------------------------------------- effects
  useEffect(() => {
    const fixedFloatingActionButtons = document.querySelectorAll(
      ".fixed-action-btn"
    );

    M.FloatingActionButton.init(fixedFloatingActionButtons, {
      hoverEnabled: false
    });
  }, []);

  // ---------------------------------------------- content
  return (
    <ThemeContext.Consumer>
      {({ theme }) => (
        <div className="container">
          <div style={{ paddingLeft: "15px", marginBottom: "10px" }}>
            <span style={{ display: "block", fontSize: "0.75rem" }}>
              {PermissionHelper.getName(MenuIndex.User).toLowerCase()}
            </span>

            <span
              style={{
                display: "inline-block",
                fontSize: "1.75rem",
                fontWeight: 300
              }}
            >
              DATA TABLE
            </span>
          </div>

          <SearchForm criteria={criteria} onFilter={onFilter} />

          {profile &&
          match &&
          PermissionHelper.getModify(profile.permissions, MenuIndex.User) ? (
            <div
              className="fixed-action-btn direction-top"
              style={{ bottom: "45px", right: "36px" }}
            >
              <button
                className="btn-floating btn-large waves-effect waves-light"
                style={{ backgroundColor: theme.ui }}
              >
                <i className="material-icons">more_vert</i>
              </button>

              <ul>
                <li>
                  <Link
                    to={`${match.url}/add`}
                    className="btn-floating waves-effect waves-light"
                    style={{ backgroundColor: theme.ui }}
                  >
                    <i className="material-icons">add</i>
                  </Link>
                </li>
              </ul>
            </div>
          ) : null}

          <table className="stripped centered">
            <thead>
              <tr>
                <th>Name</th>

                <th>Email</th>
              </tr>
            </thead>

            <tbody>
              {loading || fetching || error || !filtered.length
                ? null
                : filtered.map(user => <Row key={user.id} user={user} />)}
            </tbody>
          </table>

          <div
            className={`center-align${error ? " red-text" : ""}`}
            style={{ marginTop: "3rem" }}
          >
            {loading || fetching ? (
              <Spinner name="three-bounce" fadeIn="none" />
            ) : error ? (
              error
            ) : !filtered.length ? (
              <p className="center-align">No users found.</p>
            ) : null}
          </div>
        </div>
      )}
    </ThemeContext.Consumer>
  );
};

export default Table;
